import React from 'react';
import {Switch, Route, Redirect, HashRouter} from 'react-router-dom';

import ComoOperaSIJE from './contenido/modulo1/ComoOperaSIJE';
import CatalogoIncidentes from './contenido/modulo1/CatalogoIncidentes';
/* import TiposDeCasilla from './contenido/modulo2/TiposDeCasilla';
import Conformacion from './contenido/modulo2/Conformacion'; */
import BaseDatos from './contenido/modulo1/BaseDatos';
// import Home from './Home';
import Glosario from './contenido/Glosario';
import Normatividad from './contenido/Normatividad';
import PreguntasFrecuentes from './PreguntasFrecuentes';
import FuncionariosCasilla from './contenido/modulo2/FuncionariosCasilla';
import EtapasJornada from './contenido/modulo3/EtapasJornada';
import JornadaElectoral from './contenido/modulo3/JornadaElectoral';
import InstalacionCasillas from './contenido/modulo3/InstalacionCasillas';
import Incidentes from './contenido/modulo3/Incidentes';
import Encabezado from './Encabezado';
import Pie from './Pie';
import QueEsSIJE from './contenido/modulo1/QueEsSIJE';
// import {BrowserRouter} from 'react-router-dom';
import { createBrowserHistory } from 'history';

const Rutas = () => {
    
    // var ubicacion = `${process.env.PUBLIC_URL}`;
    // console.log("ubicacion", ubicacion);

    return (
        <div>
            <HashRouter>
            <Encabezado/>
            <Switch>
                <Redirect exact from="/" to="/QueEsSIJE" component={QueEsSIJE}/>
                <Route path="/QueEsSIJE" component={QueEsSIJE} />
                <Route path="/ComoOperaSIJE" component={ComoOperaSIJE} />
                <Route path="/CatalogoIncidentes" component={CatalogoIncidentes} />
                <Route path="/BaseDatos" component={BaseDatos} />
                {/* <Route path="/TiposCasilla" component={TiposDeCasilla} />
                <Route path="/Conformacion" component={Conformacion} /> */}
                <Route path="/FuncionariosCasilla" component={FuncionariosCasilla} />
                <Route path="/JornadaElectoral" component={JornadaElectoral} />
                {/* <Route path="/EtapasJornada" component={EtapasJornada} />
                <Route path="/InstalacionCasillas" component={InstalacionCasillas} />
                <Route path="/Incidentes" component={Incidentes} /> */}
                <Route path="/Glosario" component={Glosario} />
                <Route path="/Normatividad" component={Normatividad} />
                <Route path="/PreguntasFrecuentes" component={PreguntasFrecuentes} />
                <Route path="*" component={QueEsSIJE} />
            </Switch>
            <Pie/>
            </HashRouter>
        </div>
    )
}

export default Rutas;

export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});